import {Component, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NavigateService} from 'ngx-satoris';
import {environment} from 'src/environments/environment';
import {ApiService} from '../../shared/services/api.service';

interface LegalDoc {
  key: string;
  file: string;
}

@Component({
  selector: 'app-legal-acceptance',
  templateUrl: './legal-acceptance.component.html',
  styleUrls: ['./legal-acceptance.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LegalAcceptanceComponent {
  readonly docs: LegalDoc[] = [
    {key: 'legal.doc.cgu', file: 'cgu.pdf'},
    {key: 'legal.doc.privacy', file: 'politique-confidentialite.pdf'},
    {key: 'legal.doc.legalNotice', file: 'mentions-legales.pdf'}
  ];
  form: FormGroup;
  submitted = false;
  openedPdf: string | null = null;

  constructor(public nav: NavigateService, public api: ApiService, private formBuilder: FormBuilder, private router: Router) {
    const group: {[key: string]: FormControl} = {};
    this.docs.forEach((_, i) => group['doc' + i] = new FormControl(false, Validators.requiredTrue));
    this.form = this.formBuilder.group(group);
  }

  pdfUrl(file: string): string {
    return `${environment.baseHref}assets/legal/${file}`;
  }

  openPdf(file: string): void {
    this.openedPdf = this.pdfUrl(file);
  }

  closePdf(): void {
    this.openedPdf = null;
  }

  continue(): void {
    this.submitted = true;
    if(!this.form.valid) {
      return;
    }
    localStorage.setItem('legalAccepted', 'true');
    this.navigateOnward();
  }

  private navigateOnward(): void {
    const returnUrl = sessionStorage.getItem('legalReturnUrl');
    sessionStorage.removeItem('legalReturnUrl');
    if(returnUrl) {
      this.router.navigateByUrl(returnUrl);
    } else {
      this.nav.to('dashboard');
    }
  }
}
